import { Component, OnInit } from '@angular/core';
import { StripeIntent } from '../../models/stripe/stripe-intent';
import { FormGroup, Validators, FormControl } from '../../../../node_modules/@angular/forms';
import { StripeService } from '../../services/stripe.service';
import { AccountService } from '../../services/account.service';
import { SubscriptionService } from '../../services/subscription.service';
import { SubscriptionPlan } from '../../models/subscriptionPlan';
import { forkJoin } from '../../../../node_modules/rxjs';
import { UserSubscription } from '../../models/userSubscription';
import { Router, ActivatedRoute } from '../../../../node_modules/@angular/router';
import { AuthenticationService } from '../../services/authentication.service';
declare var Stripe;
import { environment } from '../../../environments/environment';
import { TimeZoneService } from 'src/app/services/timezone.service';
import { TimeZonePricesService } from 'src/app/services/timezoneprices.service';

@Component({
  selector: 'app-subscribe',
  templateUrl: './subscribe.component.html',
  styleUrls: ['./subscribe.component.scss']
})
export class SubscribeComponent implements OnInit {
  private publishableKey:string;
  private intent: StripeIntent;
  private stripe;
  private cardElement: any;
  public errorMessage=null;
  public stripeForm:FormGroup;
  public bacsForm:FormGroup;
  public processingPayment:boolean = false;
  public processingBacs:boolean=false;
  public selectedPlan: SubscriptionPlan;
  public subscriptionPlans: SubscriptionPlan[];
  public userSubscriptions: UserSubscription[];
  public loading: boolean = true;
  public passedInPlan:string = null;
  public mailTo: string = environment.contactFormRecipient;
  public applicationReceived:boolean=false;
  public applicationError:string='';
  public customer;
  public customerLoading:boolean=true;
  public couponCode:string='';
  public couponApplied:boolean=false;
  public discount:number=0;
  public vat:number=0;

  // TimeZones
  public DefaultTimeZone:boolean = true;
  public USATimeZone:boolean = false;
  public AustraliaTimeZone:boolean = false;
  public AucklandTimeZone:boolean = false;
  public HongKongTimeZone:boolean = false;
  public EUTimeZone:boolean = false;
  public CanadaTimeZone:boolean = false;
  public UAETimeZone:boolean = false;


  constructor(private route: ActivatedRoute,
    private stripeService: StripeService,
    private accountService: AccountService,
    private subscriptionService: SubscriptionService,
    private router: Router,
    private authenticationService: AuthenticationService,
    private timezoneService: TimeZoneService,
    private timeZonePrices: TimeZonePricesService
  ) {
    this.publishableKey=environment.stripePublishableKey;
    this.stripe=Stripe(this.publishableKey);

    this.route.queryParams.subscribe(params => {
      if(params['t']){
        this.passedInPlan=params['t'];
      }
    });

    // Check TimeZone before forkJoin so plan filtering uses correct values
    this.DefaultTimeZone = this.timezoneService.checkDefaultTimeZone();
    this.USATimeZone = this.timezoneService.checkUSATimeZone();
    this.AustraliaTimeZone = this.timezoneService.checkAustraliaTimeZone();
    this.AucklandTimeZone = this.timezoneService.checkAucklandTimeZone();
    this.HongKongTimeZone = this.timezoneService.checkHongKongTimeZone();
    this.EUTimeZone = this.timezoneService.checkEUTimeZone();
    this.CanadaTimeZone = this.timezoneService.checkCanadaTimeZone();
    this.UAETimeZone = this.timezoneService.checkUAETimeZone();

    if(!this.authenticationService.loggedIn.value){
      this.router.navigate(['/login']);
    }
    else{
      this.stripeForm = new FormGroup({
        'name': new FormControl(null, Validators.required),
        'address_line_1': new FormControl(null, Validators.required),
        'address_line_2': new FormControl(null),
        'town': new FormControl(null, Validators.required),
        'county': new FormControl(null, Validators.required),
        'postcode': new FormControl(null, Validators.required),
        'plan_id': new FormControl(null, Validators.required),
        // 'extra_annual_seats': new FormControl(null),
        // 'extra_monthly_seats': new FormControl(null),
      });

      this.bacsForm=new FormGroup({
        'practiceName': new FormControl(null, Validators.required),
        'name': new FormControl(null, Validators.required),
        'address_line_1': new FormControl(null, Validators.required),
        'address_line_2': new FormControl(null),
        'town': new FormControl(null, Validators.required),
        'county': new FormControl(null, Validators.required),
        'postcode': new FormControl(null, Validators.required),
        'telephone': new FormControl(null, Validators.required),
        'extra_annual_seats': new FormControl(null),
      });

      forkJoin(
        this.subscriptionService.getUserSubscriptions(),  
        this.subscriptionService.getPlans()
      ).subscribe( data=> {

        this.userSubscriptions = data[0];

        if(this.DefaultTimeZone && !this.EUTimeZone) this.subscriptionPlans = data[1].filter((plan: any) => [1,2,3,4].indexOf(plan.id) !== -1);

        // Price swap by TimeZone
        if(this.USATimeZone) this.subscriptionPlans = this.timeZonePrices.getUSATimeZoneZonePrice();
        if(this.DefaultTimeZone && this.EUTimeZone) this.subscriptionPlans = this.timeZonePrices.getEUTimeZonePrice();
        if(this.HongKongTimeZone) this.subscriptionPlans = this.timeZonePrices.getHongKongTimeZonePrice();
        if(this.AucklandTimeZone) this.subscriptionPlans = this.timeZonePrices.getAucklandTimeZonePrice();
        if(this.AustraliaTimeZone) this.subscriptionPlans = this.timeZonePrices.getAustraliaTimeZonePrice();
        if(this.CanadaTimeZone) this.subscriptionPlans = this.timeZonePrices.getCanadaTimeZonePrice();
        if(this.UAETimeZone) this.subscriptionPlans = this.timeZonePrices.getUAETimeZonePrice()

        // Sync stripe_reference from API only for GBP — country-specific timezones use their own Stripe price references
        if(this.DefaultTimeZone && !this.EUTimeZone && this.subscriptionPlans && data[1]) {
          this.subscriptionPlans.forEach(plan => {
            const apiPlan = data[1].find((p: any) => p.id === plan.id);
            if(apiPlan) plan.stripe_reference = apiPlan.stripe_reference;
          });
        }

        if(this.passedInPlan){
          this.stripeForm.get('plan_id').setValue(this.passedInPlan);
          this.planSelected(this.passedInPlan);
        }


        this.loading = false;
      });
    }
  }

  public calcVAT(){
    this.vat=((this.selectedPlan.amount-this.discount)/100)*0.2;
  }

  public applyCoupon(){
    this.stripeService.applyCoupon(this.couponCode).subscribe(
      res=>{
        // console.log(res);
        this.getCustomer();
      }
    );
  }

  public getCustomer(){
    this.stripeService.getCustomer().subscribe(
      res=>{
        this.customer=res;
        if(this.customer) this.checkDiscounts();
        this.customerLoading=false;
      },
      err=>{
        this.customerLoading=false;
      }
    );
  }

  private checkDiscounts(){
    if(this.customer.discount && this.customer.discount.coupon.valid){
      //this.couponApplied=true;
      if (this.customer.discount.coupon.amount_off) {
        this.discount=this.customer.discount.coupon.amount_off;
      } else {
        this.discount=(this.selectedPlan.amount)/100*this.customer.discount.coupon.percent_off;
      }
      this.calcVAT();
    }
  }

  applyForBacs(){
    this.processingBacs=true;
    let application={
      practice_name: this.bacsForm.get('practiceName').value,
      name: this.bacsForm.get('name').value,
      address_line_1: this.bacsForm.get('address_line_1').value,
      address_line_2: this.bacsForm.get('address_line_2').value,
      town: this.bacsForm.get('town').value,
      county: this.bacsForm.get('county').value,
      postcode: this.bacsForm.get('postcode').value,
      telephone: this.bacsForm.get('telephone').value,
      additional_seats: this.bacsForm.get('extra_annual_seats').value
    };
    this.accountService.applyForBacs(application, this.mailTo).subscribe(
      res=>{
        if(res.status=='failed') {
          this.processingBacs=false;
          this.bacsForm.reset();
          this.applicationError=res.message;
        }
        if(res.practice_name==application.practice_name) {

          window["dataLayer"].push({ ecommerce: null });  // Clear the previous ecommerce object.
          window["dataLayer"].push({
            event: "purchase",
            ecommerce: {
              items: [
                {
                  item_name: application.name,
                  quantity: 1
                }]
            }
          });

          this.processingBacs=false;
          this.bacsForm.reset();
          this.applicationReceived=true;
        }
      }
    );
  }

  ngOnInit() {
    this.getCustomer();
    var elements = this.stripe.elements();
    this.cardElement = elements.create('card');
    this.cardElement.mount('#card-element');

    // Check TimeZone
    this.DefaultTimeZone = this.timezoneService.checkDefaultTimeZone();
    this.USATimeZone = this.timezoneService.checkUSATimeZone();
    this.AustraliaTimeZone = this.timezoneService.checkAustraliaTimeZone();
    this.AucklandTimeZone = this.timezoneService.checkAucklandTimeZone();
    this.HongKongTimeZone = this.timezoneService.checkHongKongTimeZone();
    this.EUTimeZone = this.timezoneService.checkEUTimeZone();
    this.CanadaTimeZone = this.timezoneService.checkCanadaTimeZone();
    this.UAETimeZone = this.timezoneService.checkUAETimeZone();
  }

  // Selected plan event from "Select a Plan"
  planSelected(plan_id){
    this.selectedPlan=this.subscriptionPlans.filter(plan=>{
      return plan.id==plan_id;
    })[0];
    if(this.DefaultTimeZone && !this.EUTimeZone) this.calcVAT();
  }

  createCard(event: any){
    event.stopPropagation();

    this.errorMessage=null;
    this.processingPayment = true;
    this.stripe.createToken(this.cardElement).then((result)=> {
      if (result.error) {
        this.errorMessage = result.error.message;
        this.processingPayment = false;
      } else {
        this.stripeService.createCustomer(result.token.id).subscribe(res=>{
          this.stripeService.createSubscription(this.selectedPlan.stripe_reference, 1, false, this.timezoneService.getResolvedCountry()).subscribe(res=>{
            if(res.status=='incomplete'){
              this.completePayment(res.latest_invoice.payment_intent,res.id);
            }else if(res.status=='active'){
              this.stripeService.sendNotification(res.id, this.selectedPlan.amount, this.discount, this.vat).subscribe();

              if(window["dataLayer"]) {
                window["dataLayer"].push({ ecommerce: null });
                window["dataLayer"].push({
                  event: "purchase",
                  ecommerce: {
                    transaction_id: res.id,
                    items: [{ price: this.selectedPlan.amount, quantity: 1 }]
                  }
                });
              }

              this.router.navigate(['/account']);
            } else {
              this.errorMessage = 'Unexpected subscription status: ' + res.status;
              this.processingPayment = false;
            }
          }, err=>{
            this.processingPayment = false;
            this.errorMessage = err.error ? err.error.message : 'Subscription error';
          })
        }, err=>{
          this.processingPayment = false;
          this.errorMessage = err.error ? err.error.message : 'Customer error';
        })
      }
    }).catch(err => {
      this.processingPayment = false;
      this.errorMessage = 'Payment error: ' + err.message;
    });
  }

  testSendNotification(){
    //this.stripeService.sendNotification(47).subscribe();
  }

  completePayment(intent,sub_id){
      this.stripe.confirmCardPayment(
        intent.client_secret, {
          payment_method: {
            card: this.cardElement,
            billing_details: {name: this.stripeForm.get('name').value}
          }
        }
      ).then((result)=> {
        if (result.error) {
            this.errorMessage = result.error.message;
            this.processingPayment = false;

        } else {
          this.stripeService.validateSubscription(sub_id).subscribe(res=>{
            if(res.status=="active"){
              this.router.navigate(['/account']);
            }
            else{
              this.processingPayment = false;
            }
            this.stripeService.sendNotification(sub_id, this.selectedPlan.amount, this.discount, this.vat).subscribe();
          })
        }
      });
  }
}
